import * as React from 'react';

import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form';

import FormInput from '../../../components/FormInput';
import FormInputSelect from '../../../components/FormInputSelect';
import AllWorkspacesQuery from '../../../graphql/queries/AllWorkspacesQuery';

interface Props {
  change: (field: string, value: any) => void;
}

export interface WorkspaceOptions {
  id: number;
  label: string;
  value: string;
}

const WorkspaceOptionsSuperAdmin: React.FC<Props> = ({ change }) => {
  const { t } = useTranslation();
  const [workspaceOptions, setWorkspaceOptions] = React.useState<
    WorkspaceOptions[]
  >([]);

  const { data, loading } = useQuery(AllWorkspacesQuery);

  React.useEffect(() => {
    if (data) {
      setWorkspaceOptions(
        data.allProducers.nodes.map((d) => ({
          id: d.id,
          label: d.name,
          value: d.name,
        })).sort((a, b) => a.label.localeCompare(b.label)),
      );
    }
  }, [data, loading]);

  return (
    <Field
      key={workspaceOptions.length}
      name="workspace_id"
      component={FormInput}
      inputComponent={FormInputSelect}
      customLabel
      labelText={t('reports.targetWorkspaceLabel')}
      options={workspaceOptions}
      isSearchable
      hideSelectedOptions={false}
      placeholder={t('reports.targetWorkspacePlaceholder')}
      closeMenuOnSelect={true}
      required
      value={(val) => val.value}
      onChange={(_, newValue) => {
        change('workspace_id', newValue.value);
      }}
    />
  );
};

export default WorkspaceOptionsSuperAdmin;
